import React from "react";
import Modal from "../Modal/Modal";
import { useEventEmitter } from "../../contexts/EventEmmiter";
import { useConstants } from "../../constant/constantProvider";
import "./MissedAlertsModal.css";

const MissedAlertsModal = ({ open, onClose, alerts, isLoading }) => {
  const { emit } = useEventEmitter();
  const { MISSED_ALERTS_TITLE, MISSED_ALERTS_SUBTITLE, MISSED_ALERTS_EMPTY } = useConstants();

  const handleAlertClick = (alert) => {
    onClose();
    if (alert) {
      emit("missedAlertClicked", alert);
    }
  };

  return (
    <Modal open={open} onClose={onClose} className="di-missed-alerts-modal-wrapper">
      <div className="di-missed-alerts-modal-content">
        <div className="di-missed-alerts-modal-header">
          <div className="di-missed-alerts-modal-title">
            <h3>{MISSED_ALERTS_TITLE}</h3>
            <p>{MISSED_ALERTS_SUBTITLE}</p>
          </div>
          <button className="di-missed-alerts-modal-close" onClick={onClose}>
            &times;
          </button>
        </div>
        <div className="di-missed-alerts-modal-body thin-scroll">
          {isLoading ? (
            <div className="loading-state">
              <div className="spinner-small"></div>
            </div>
          ) : alerts?.length > 0 ? (
            alerts.map((alert, index) => (
              <div 
                key={alert.alert_id || index}
                className="di-missed-alert-modal-item"
                onClick={() => handleAlertClick(alert)}
              >
                <div className="di-missed-alert-modal-item-header">
                  <h4>{alert.alert_domain || 'ALERT'}</h4>
                </div>
                <p className="di-missed-alert-modal-item-desc">{alert.headline}</p>
              </div>
            ))
          ) : (
            <div className="empty-state">{MISSED_ALERTS_EMPTY}</div>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default MissedAlertsModal;
